import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateFullPage1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 1404 1080",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "empty-state-full-page-1_svg__a",
			width: 1182,
			height: 1085,
			x: 226,
			y: -4,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#E85656",
				d: "M1407.25-3.001H1086c-137.253 0-420.719.003-420.719.005 46 247.952-62.861 404.515-249.006 466.804-186.138 62.312-216.364 447.341-170.499 616.542H1407.25z"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#empty-state-full-page-1_svg__a)",
			children: [/* @__PURE__ */ _jsxs("g", {
				clipPath: "url(#empty-state-full-page-1_svg__b)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						fill: "#E9FFFE",
						d: "M1405-4H-612v942h2017z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#CED0E0",
						d: "M816.229 469.629h-62.642v291.052h62.642z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#123E6B",
						d: "M853.034 469.629h-36.805v291.052h36.805z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#123E6B",
						d: "M853.031 760.681h-36.802V469.629z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#fff",
						d: "M767.943 481h-5.363v7.532h5.363zM780.998 481h-5.363v7.532h5.363zM794.054 481h-5.363v7.532h5.363zM807.106 481h-5.363v7.532h5.363zM767.943 502.79h-5.363v7.532h5.363zM780.998 502.79h-5.363v7.532h5.363zM794.054 502.79h-5.363v7.532h5.363zM807.106 502.79h-5.363v7.532h5.363zM767.943 524.583h-5.363v7.532h5.363zM780.998 524.583h-5.363v7.532h5.363zM794.054 524.583h-5.363v7.532h5.363zM807.106 524.583h-5.363v7.532h5.363zM767.943 546.373h-5.363v7.532h5.363zM780.998 546.373h-5.363v7.532h5.363zM794.054 546.373h-5.363v7.532h5.363zM807.106 546.373h-5.363v7.532h5.363zM767.943 568.166h-5.363v7.532h5.363zM780.998 568.166h-5.363v7.532h5.363zM794.054 568.166h-5.363v7.532h5.363zM807.106 568.166h-5.363v7.532h5.363zM767.943 589.959h-5.363v7.532h5.363zM780.998 589.959h-5.363v7.532h5.363zM794.054 589.959h-5.363v7.532h5.363zM807.106 589.959h-5.363v7.532h5.363zM767.943 611.749h-5.363v7.532h5.363zM780.998 611.749h-5.363v7.532h5.363zM794.054 611.749h-5.363v7.532h5.363zM807.106 611.749h-5.363v7.532h5.363zM767.943 633.541h-5.363v7.532h5.363zM780.998 633.541h-5.363v7.532h5.363zM794.054 633.541h-5.363v7.532h5.363zM807.106 633.541h-5.363v7.532h5.363zM767.943 655.334h-5.363v7.532h5.363zM780.998 655.334h-5.363v7.532h5.363zM794.054 655.334h-5.363v7.532h5.363zM807.106 655.334h-5.363v7.532h5.363zM767.943 677.124h-5.363v7.532h5.363zM780.998 677.124h-5.363v7.532h5.363zM794.054 677.124h-5.363v7.532h5.363zM807.106 677.124h-5.363v7.532h5.363zM767.943 698.917h-5.363v7.532h5.363zM780.998 698.917h-5.363v7.532h5.363zM794.054 698.917h-5.363v7.532h5.363zM807.106 698.917h-5.363v7.532h5.363zM767.943 720.71h-5.363v7.532h5.363zM780.998 720.71h-5.363v7.532h5.363zM794.054 720.71h-5.363v7.532h5.363zM807.106 720.71h-5.363v7.532h5.363zM767.943 742.5h-5.363v7.532h5.363zM780.998 742.5h-5.363v7.532h5.363zM794.054 742.5h-5.363v7.532h5.363zM807.106 742.5h-5.363v7.532h5.363z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#B3B3B3",
						d: "M708.945 548.678h-74.861v214.911h74.861z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#757575",
						d: "M753.584 548.678h-44.642v214.911h44.642z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#fff",
						d: "M698.3 555.211h-53.571v3.606H698.3zM698.3 565.645h-53.571v3.605H698.3zM698.3 576.078h-53.571v3.606H698.3zM698.3 586.512h-53.571v3.605H698.3zM698.3 596.944h-53.571v3.606H698.3zM698.3 607.381h-53.571v3.606H698.3zM698.3 617.814h-53.571v3.606H698.3zM698.3 628.248h-53.571v3.606H698.3zM698.3 638.682h-53.571v3.605H698.3zM698.3 649.115h-53.571v3.606H698.3zM698.3 659.548h-53.571v3.606H698.3zM698.3 669.981h-53.571v3.606H698.3zM698.3 680.415h-53.571v3.606H698.3zM698.3 690.849h-53.571v3.605H698.3zM698.3 701.282h-53.571v3.606H698.3zM698.3 711.716h-53.571v3.606H698.3zM698.3 722.149h-53.571v3.606H698.3zM698.3 732.585h-53.571v3.606H698.3zM698.3 743.019h-53.571v3.605H698.3zM698.3 753.452h-53.571v3.606H698.3z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#CED0E0",
						d: "M742.253 555.211h-21.977v3.606h21.977zM742.253 565.645h-21.977v3.605h21.977zM742.253 576.078h-21.977v3.606h21.977zM742.253 586.512h-21.977v3.605h21.977zM742.253 596.944h-21.977v3.606h21.977zM742.253 607.381h-21.977v3.606h21.977zM742.253 617.814h-21.977v3.606h21.977zM742.253 628.248h-21.977v3.606h21.977zM742.253 638.682h-21.977v3.605h21.977zM742.253 649.115h-21.977v3.606h21.977zM742.253 659.548h-21.977v3.606h21.977zM742.253 669.981h-21.977v3.606h21.977zM742.253 680.415h-21.977v3.606h21.977zM742.253 690.849h-21.977v3.605h21.977zM742.253 701.282h-21.977v3.606h21.977zM742.253 711.716h-21.977v3.606h21.977zM742.253 722.149h-21.977v3.606h21.977zM742.253 732.585h-21.977v3.606h21.977zM742.253 743.019h-21.977v3.605h21.977zM742.253 753.452h-21.977v3.606h21.977z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#0A1866",
						d: "M568.919 702.037s-6.219-30.994 23.695-35.494c17.994-2.709 12.701-14.697 29.282-21.274 13.676-5.423 24.012 3.894 34.366-.75 16.36-7.335 13.6-18.931 39.066-21.897 12.109-1.41 16.183-11.809 29.628-11.774 20.264.052 28.625 16.909 28.625 16.909v74.28H568.916z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#17AD86",
						d: "M-7.77 768.683c70.909 15.161 51.822 27.781 115.995 34.995 59.577 6.698 85.895-36.913 157.074-22.3 81.239 16.678 84.151-73.513 160.224-62.933 69.956 9.73 80.111-32.967 143.399-15.645 27.18 7.439 83.664 98.842 105.467 112.226v34.286l-803.858 18.239v-98.908c35.3-4.682 86.83-7.414 121.7.043z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#C0C94D",
						d: "M361.191 851.634c-31.578 7.886-30.917-8.596-68.812-18.072-40.62-10.156-63.187 14.671-95.909 13.543-55.085-1.901-71.084-16.929-119.604-21.444-33.728-3.138-71.378 6.196-100.392 21.66-17.24 9.191-38.022 10.742-56.838 4.662-15.212-4.915-28.747-7.22-38.08-7.22-50.558 0-61.41 10.101-90.889 22.447-21.671 9.078-31.108-10.785-65.545-2.78-30.71 7.139-25.987 27.066-53.047 29.61-77.003 7.234-77.413 44.837-91.226 44.03h780.342v-86.439z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#66C8CE",
						d: "M1405.11 938.147H-612.356v141.893H1405.11z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#D4FDFB",
						d: "M796.196 960.959h-82.401a3.25 3.25 0 0 1 0-6.502h82.401a3.25 3.25 0 0 1 3.249 3.251 3.25 3.25 0 0 1-3.249 3.251M969.119 982.114H803.727a3.25 3.25 0 0 1 0-6.502h165.392a3.25 3.25 0 0 1 0 6.502M916.783 994.815H814.357a3.25 3.25 0 0 1-3.249-3.251 3.25 3.25 0 0 1 3.249-3.251h102.426a3.25 3.25 0 0 1 3.249 3.251 3.25 3.25 0 0 1-3.249 3.251"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#D4FDFB",
						d: "M905.028 985.215c0-1.794 1.453-3.101 3.249-3.101h-18.606v6.205h18.606c-1.793 0-3.249-1.307-3.249-3.101z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#D4FDFB",
						d: "M817.606 985.215c0 1.794-1.453 3.101-3.249 3.101h78.857v-6.205h-78.857c1.793 0 3.249 1.307 3.249 3.101zM1289.66 955.594h115.45v19.202h-63.12a3.253 3.253 0 0 1-3.25-3.251 3.253 3.253 0 0 1 3.25-3.251h8.51c1.79 0 3.25-1.306 3.25-3.1s-1.46-3.101-3.25-3.101h-60.84c-1.8 0-3.25-1.454-3.25-3.251a3.246 3.246 0 0 1 3.25-3.251z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#123E6B",
						d: "M253.951 824.13c0 24.06-17.305 43.568-17.305 43.568s-17.306-19.505-17.306-43.568 17.306-43.568 17.306-43.568 17.305 19.505 17.305 43.568"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#006168",
						d: "M238.035 818.822h-2.773v73.138h2.773z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#0E664F",
						d: "M297.272 824.13c0 24.06-17.305 43.568-17.305 43.568s-17.306-19.505-17.306-43.568 17.306-43.568 17.306-43.568 17.305 19.505 17.305 43.568"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#006168",
						d: "M281.354 818.822h-2.774v73.138h2.774z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#048982",
						d: "M340.593 824.13c0 24.06-17.305 43.568-17.305 43.568s-17.305-19.505-17.305-43.568 17.305-43.568 17.305-43.568 17.305 19.505 17.305 43.568"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#006168",
						d: "M324.675 818.822h-2.774v73.138h2.774z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#5F89BA",
						d: "M1042.36 938.148h-77.285V698.741l77.285-17.18z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#344B66",
						d: "M1120 681.561h-77.29v256.587H1120z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#048982",
						d: "m853.031 879.378-144.657-8.25 7.86-169.09h136.797z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#123E6B",
						d: "M765.186 740.339c0 14.907-15.665 26.993-15.665 26.993s-15.665-12.086-15.665-26.993c0-6.56 3.034-12.574 6.43-17.25 4.544-6.259 13.926-6.259 18.47 0 3.397 4.679 6.43 10.69 6.43 17.25"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#006168",
						d: "M750.652 737.048h-2.258v66.803h2.258z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#17AD86",
						d: "M804.399 740.339c0 14.907-15.665 26.993-15.665 26.993s-15.665-12.086-15.665-26.993c0-6.56 3.033-12.574 6.43-17.25 4.544-6.259 13.926-6.259 18.47 0 3.396 4.679 6.43 10.69 6.43 17.25"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#006168",
						d: "M789.864 737.048h-2.257v45.316h2.257z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ADD57F",
						d: "M843.611 740.339c0 14.907-15.665 26.993-15.665 26.993s-15.665-12.086-15.665-26.993c0-6.56 3.034-12.574 6.43-17.25 4.544-6.259 13.926-6.259 18.47 0 3.397 4.679 6.43 10.69 6.43 17.25"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#006168",
						d: "M829.077 737.048h-2.258v45.316h2.258z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#0A1866",
						d: "M869.984 809.409c0-6.45-7.329-11.676-16.371-11.676q-.879 0-1.736.066c.052-.456.098-.915.098-1.379 0-9.106-10.353-16.491-23.123-16.491-3.302 0-6.436.502-9.276 1.39-.675-6.005-7.71-10.733-16.305-10.733s-15.662 4.751-16.308 10.777a36 36 0 0 0-7.839-.854c-14.468 0-26.195 8.362-26.195 18.68 0 .335.046.661.07.993-2.235-.814-4.758-1.284-7.439-1.284-9.042 0-16.372 5.227-16.372 11.677s7.33 11.676 16.372 11.676c.986 0 1.952-.063 2.889-.181 7.43 4.344 28.426 7.479 53.184 7.479 26.939 0 49.215 45.772 54.615 40.828 7.681-.963 13.739-55.213 13.739-60.968z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#1FB578",
						d: "m761.49 816.298-19.704 23.717-150.23 1.742-30.162-62.148h155.351z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#848BB2",
						d: "M909.053 422.489h-56.022v279.549h56.022z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#565C80",
						d: "M965.075 702.038h-56.022V422.489l56.022 36.386z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#fff",
						d: "M865.87 434.27h-4.795v262.287h4.795zM877.544 434.27h-4.794v262.287h4.794zM889.222 434.27h-4.795v262.287h4.795zM900.896 434.27h-4.795v262.287h4.795zM917.201 696.557h4.797V437.324l-4.705-3.054h-.092zM933.673 696.556V444.907l-4.798-3.115v254.764zM945.347 696.557V452.488l-4.795-3.112v247.181zM957.021 696.557V460.072l-4.794-3.115v239.6z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#5F89BA",
						d: "M1042.36 702.037h-77.285V485.661l77.285-17.181z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#344B66",
						d: "M1120 468.48h-77.29v233.557H1120z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#fff",
						d: "M1042.36 485.661h-77.285v2.965h77.285zM1042.36 503.601h-77.285v2.965h77.285zM1042.36 521.54h-77.285v2.965h77.285zM1042.36 539.479h-77.285v2.965h77.285zM1042.36 557.415h-77.285v2.965h77.285zM1042.36 575.354h-77.285v2.965h77.285zM1042.36 593.293h-77.285v2.965h77.285zM1042.36 611.232h-77.285v2.966h77.285zM1042.36 629.168h-77.285v2.965h77.285zM1042.36 647.107h-77.285v2.966h77.285zM1042.36 665.047h-77.285v2.965h77.285zM1042.36 682.985h-77.285v2.966h77.285z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#848BB2",
						d: "M1119.64 485.661h-77.28v2.965h77.28zM1119.64 503.601h-77.28v2.965h77.28zM1119.64 521.539h-77.28v2.965h77.28zM1119.64 539.479h-77.28v2.965h77.28zM1119.64 557.414h-77.28v2.965h77.28zM1119.64 575.354h-77.28v2.965h77.28zM1119.64 593.293h-77.28v2.965h77.28zM1119.64 611.231h-77.28v2.966h77.28zM1119.64 629.168h-77.28v2.965h77.28zM1119.64 647.107h-77.28v2.966h77.28zM1119.64 665.046h-77.28v2.965h77.28zM1119.64 682.985h-77.28v2.966h77.28z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ADD57F",
						d: "M1101.75 717.574c-.97-1.264-1.1-2.977-.43-4.425a17.3 17.3 0 0 0 1.59-7.258c0-5.258-2.34-9.963-6.04-13.139-1.55-1.327-2.06-3.56-1.07-5.339.9-1.633 1.43-3.505 1.45-5.501.07-6.274-5.07-11.637-11.34-11.815-6.61-.188-12.03 5.114-12.03 11.682 0 2.048.53 3.969 1.46 5.639.99 1.78.47 4.01-1.08 5.337-3.69 3.179-6.04 7.88-6.04 13.139 0 2.593.57 5.054 1.59 7.263.68 1.463.52 3.185-.46 4.466-2.88 3.755-4.47 8.535-4.15 13.696.64 10.251 9.12 18.593 19.37 19.081 11.73.557 21.4-8.786 21.4-20.388 0-4.679-1.57-8.991-4.22-12.433z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#048982",
						d: "M1011.84 724.849c.15-.961.17-1.959.08-2.977-.55-5.68-5.08-10.292-10.75-10.918-7.355-.813-13.577 4.924-13.577 12.115q0 .7.078 1.385c.502 4.436.014 8.965-1.788 13.049a15.2 15.2 0 0 0-1.251 7.122c.485 7.52 6.56 13.627 14.076 14.146 8.872.612 16.262-6.406 16.262-15.149 0-2.167-.45-4.223-1.27-6.087-1.75-3.983-2.48-8.382-1.86-12.686"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#006168",
						d: "M1000.13 726.949h-2.255v85.776h2.255z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#17AD86",
						d: "M1046.43 708.49c.18-1.264.22-2.576.09-3.92-.71-7.477-6.68-13.549-14.14-14.371-9.68-1.07-17.87 6.482-17.87 15.949 0 .617.03 1.223.1 1.823.66 5.838.02 11.8-2.35 17.177a19.94 19.94 0 0 0-1.65 9.375c.64 9.897 8.64 17.939 18.53 18.62 11.68.805 21.4-8.432 21.4-19.941 0-2.85-.6-5.561-1.67-8.013-2.3-5.244-3.27-11.034-2.44-16.699"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#006168",
						d: "M1030.6 711.146h-2.26v65.46h2.26zM1085.88 708.891h-2.25v68.845h2.25z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#1FB578",
						d: "m626.365 702.038-28.697-27.507h90.379l28.697 27.507z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#E6FDDE",
						d: "m597.856 674.505-28.689 27.507v77.603h57.377v-77.603z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ADD57F",
						d: "M716.744 702.038h-90.379v77.572h90.379z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#048982",
						d: "m965.075 709.151-56.022-45.498v-51.394l56.022 45.495z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ADD57F",
						d: "m853.031 709.151 56.022-45.498v-51.394l-56.022 45.495z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#fff",
						d: "m909.105 663.627-55.936 45.498v226.833H965.04V709.125z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#CED0E0",
						d: "M874.97 737.919h-6.197v6.334h6.197zM874.97 756.926h-6.197v6.334h6.197zM874.97 775.935h-6.197v6.334h6.197zM893.561 718.913h-6.196v6.335h6.196zM893.561 737.919h-6.196v6.334h6.196zM893.561 756.926h-6.196v6.334h6.196zM893.561 775.935h-6.196v6.334h6.196zM912.152 699.906h-6.196v6.335h6.196zM912.152 718.913h-6.196v6.335h6.196zM912.152 737.919h-6.196v6.334h6.196zM912.152 756.926h-6.196v6.334h6.196zM912.152 775.935h-6.196v6.334h6.196zM930.743 718.913h-6.196v6.335h6.196zM930.743 737.919h-6.196v6.334h6.196zM930.743 756.926h-6.196v6.334h6.196zM930.743 775.935h-6.196v6.334h6.196zM949.335 737.919h-6.196v6.334h6.196zM949.335 756.926h-6.196v6.334h6.196zM949.335 775.935h-6.196v6.334h6.196zM874.97 794.941h-6.197v6.335h6.197zM893.561 794.941h-6.196v6.335h6.196zM912.152 794.941h-6.196v6.335h6.196zM930.743 794.941h-6.196v6.335h6.196zM949.335 794.941h-6.196v6.335h6.196z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#73DDDA",
						d: "M728.047 777.963c0 20.201-14.529 36.576-14.529 36.576s-14.529-16.375-14.529-36.576 14.529-36.576 14.529-36.576 14.529 16.375 14.529 36.576"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#006168",
						d: "M714.648 771.524h-2.257v48.527h2.257z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#006168",
						d: "m713.521 787.531-6.165-6.303 1.612-1.578 4.553 4.653 4.549-4.653 1.615 1.578z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#123E6B",
						d: "M682.52 779.258c0 17.844-12.834 32.307-12.834 32.307s-12.833-14.466-12.833-32.307 12.833-32.307 12.833-32.307 12.834 14.466 12.834 32.307"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#048982",
						d: "M705.283 764.593c0 20.2-14.528 36.576-14.528 36.576s-14.529-16.376-14.529-36.576c0-20.201 14.529-36.576 14.529-36.576s14.528 16.375 14.528 36.576"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#006168",
						d: "M691.885 760.136h-2.258v61.401h2.258z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#048982",
						d: "M670.817 773.506h-2.258v47.041h2.258z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#17AD86",
						d: "M739.427 838.853H624.904v99.295h114.523z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#C0C94D",
						d: "m624.904 838.852-32.769-35.967s37.514-15.274 58.582-1.16c28.992 19.419 39.516 1.549 71.344 5.221 30.162 3.482 60.641 31.906 60.641 31.906H624.901z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#0A1866",
						d: "M624.903 825.292c17.104-1.903 21.371 20.856 30.843 27.369 9.488 6.525 11.192-6.444 29.005-6.513 20.232-.078 15.694-8.256 26.639-13.618 10.446-5.12 23.68.591 28.034 6.323 14.085 18.53 61.762 65.029 61.762 65.029l-37.292-4.456-138.994-7.145v-66.989z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#1FB578",
						d: "m646.306 823.622-13.245 46.214 37.488 15.057-14.791-61.262c-1.217-5.042-8.224-5.051-9.455-.011z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#048982",
						d: "M652.185 834.656h-2.257v36.106h2.257z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#048982",
						d: "M649.928 861.494V850.87l-5.006-7.909 1.906-1.206 5.357 8.46v5.743l5.363-5.483 1.612 1.578z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#1FB578",
						d: "m669.05 821.545-13.932 69.432 38.174 4.151-14.791-73.571c-1.217-5.042-8.223-5.051-9.454-.012z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#048982",
						d: "M674.929 832.579h-2.258v51.902h2.258z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#048982",
						d: "M672.671 859.417v-10.624l-5.005-7.907 1.906-1.208 5.357 8.46v5.743l5.363-5.483 1.611 1.578z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#C0C94D",
						d: "M624.903 865.468c11.868-3.103 26.146 5.585 32.924 13.03 6.782 7.445 11.141.413 19.615 3.309 11.164 3.813 18.926 16.26 32.004 14.192 13.076-2.069 22.242 4.009 22.242 4.009l7.739 38.14H624.903z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#006168",
						d: "M624.903 903.519c15.201-14.605 22.369 1.281 35.56-2.04 10.936-2.751 13.39-7.935 30.542-11.63 10.414-2.244 14.771 1.122 22.037-6.355 7.09-7.298 5.57-17.195 26.385-20.31 22.835-3.415 28.054 11.178 28.054 11.178l-5.994 17.61-16.458 46.176H624.9v-34.626z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#08124A",
						d: "m783.55 838.852-22.06-22.554h69.481l22.06 22.554z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#CED0E0",
						d: "m761.625 816.272-22.057 22.555v99.439h44.114v-99.439z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#848BB2",
						d: "M853.031 838.853H783.55v99.295h69.481zM847.336 838.852l-22.063-22.554h-2.202l22.062 22.554zM838.023 838.852l-22.063-22.554h-2.205l22.062 22.554zM828.707 838.852l-22.062-22.554h-2.203l22.062 22.554zM819.392 838.852l-22.06-22.554h-2.206l22.063 22.554zM810.078 838.852l-22.062-22.554h-2.203l22.063 22.554zM800.763 838.852l-22.06-22.554h-2.206l22.063 22.554zM791.45 838.852l-22.063-22.554h-2.203l22.063 22.554z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#C9ECF4",
						d: "M1405.6 290.836c-2.3 1.018-4.24 2.25-6.12 3.692-1.72-17.097-15.87-30.432-33.05-30.432-8.49 0-16.23 3.288-22.1 8.648-4.87-12.554-16.83-21.441-30.85-21.441-17.48 0-31.78 13.828-33.07 31.366-4.97-3.031-10.73-4.805-16.94-4.805-18.33 0-33.17 15.196-33.17 33.939v1.088h175.3v-22.058zM1022.19 355.051c-3.26 0-6.35.71-9.15 1.965-.66-8.487-7.59-15.164-16.065-15.164-8.471 0-15.437 6.712-16.072 15.227a25.3 25.3 0 0 0-7.727-1.206c-12.389 0-22.731 8.928-25.231 20.833h96.945c-.83-12.098-10.66-21.658-22.71-21.658zM1405.6 362.038c-12.11 1.613-21.29 11.573-22.22 23.962-3.88-1.243-8.03-1.866-12.31-1.866-19.71 0-36.18 14.146-40.15 33.184h74.68v-55.28"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#048982",
						d: "m417.989 738.978-56.284 57.394h150.63l56.285-57.394z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#fff",
						d: "m568.735 738.954-56.368 57.391v141.921h112.736V796.345z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#006168",
						d: "m464.868 796.371-27.847-28.395h55.694z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#E9EAF2",
						d: "m464.96 796.345-27.846-28.396-27.844 28.396h-47.41v141.92h150.507v-141.92z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#CED0E0",
						d: "M539.32 833.415h-5.53v6.424h5.53zM539.32 852.684h-5.53v6.424h5.53zM539.32 871.953h-5.53v6.424h5.53zM539.32 891.225h-5.53v6.424h5.53zM555.913 833.415h-5.53v6.424h5.53zM555.913 852.684h-5.53v6.424h5.53zM555.913 871.953h-5.53v6.424h5.53zM555.913 891.225h-5.53v6.424h5.53zM572.503 833.415h-5.53v6.424h5.53zM572.503 852.684h-5.53v6.424h5.53zM572.503 871.953h-5.53v6.424h5.53zM572.503 891.225h-5.53v6.424h5.53zM589.096 833.415h-5.53v6.424h5.53zM589.097 852.684h-5.531v6.424h5.531zM589.097 871.953h-5.531v6.424h5.531zM589.096 891.225h-5.53v6.424h5.53zM605.687 833.415h-5.53v6.424h5.53zM605.687 852.684h-5.53v6.424h5.53zM605.687 871.953h-5.53v6.424h5.53zM605.687 891.225h-5.53v6.424h5.53z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#848BB2",
						d: "M383.107 833.198h-7.076v23.371h7.076zM411.946 833.198h-7.076v23.371h7.076zM440.784 833.198h-7.076v23.371h7.076zM469.622 833.198h-7.075v23.371h7.075zM498.461 833.198h-7.076v23.371h7.076zM383.107 874.49h-7.076v23.371h7.076zM411.946 874.49h-7.076v23.371h7.076zM440.784 874.49h-7.076v23.371h7.076zM469.622 874.49h-7.075v23.371h7.075zM498.461 874.49h-7.076v23.371h7.076z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#0A1866",
						d: "M1096.98 775.531c-4.33 0-8.36.882-11.83 2.388-.9-8.723-10.86-15.6-23.04-15.6-9.77 0-18.11 4.419-21.5 10.665-4.09-2.666-9.48-4.301-15.39-4.301-11.97 0-21.82 6.631-23.02 15.135-3.867-2.12-8.659-3.392-13.869-3.392-12.779 0-23.138 7.557-23.138 16.877 0 .124.02.243.026.364-.009 0-.017-.006-.026-.009v140.487h154.927v-145.74c0-9.323-10.36-16.877-23.14-16.877z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#006168",
						d: "m1069.44 835.077-26.73-51.135h50.56l26.73 51.135z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ADD57F",
						d: "M1120 835.077h-50.56v103.071H1120z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#fff",
						d: "M1042.89 783.916v154.35h26.52V835.051z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#1FB578",
						d: "M1100.36 855.078h-10.87v12.868h10.87zM1100.36 884.547h-10.87v12.868h10.87z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#048982",
						d: "M1002.06 830.643c0 18.254-13.132 33.052-13.132 33.052S975.8 848.897 975.8 830.643q.002-.761.029-1.511c.66-16.837 25.531-16.837 26.201 0q.03.753.03 1.511"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#006168",
						d: "M990.058 840.099H987.8V914.8h2.258z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ADD57F",
						d: "M1034.92 830.643c0 18.254-13.13 33.052-13.13 33.052s-13.13-14.798-13.13-33.052c0-.507.02-1.012.03-1.511.66-16.837 25.54-16.837 26.2 0q.03.753.03 1.511"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#006168",
						d: "M1022.92 840.099h-2.26V914.8h2.26z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#54A36A",
						d: "M1042.24 921.186c0-10.84-8.59-25.698-19.2-25.698-5.65 0-10.71 2.507-14.22 6.476-.33-10.543-8.77-18.992-19.168-18.992a18.7 18.7 0 0 0-8.091 1.846c.003-.141.02-.28.02-.424 0-10.84-8.595-19.63-19.199-19.63-4.325 0-8.301 1.48-11.51 3.947-.992-9.889-9.163-17.599-19.096-17.599-4.91 0-9.377 1.901-12.773 5.002-2.817-7.261-9.734-12.401-17.839-12.401-10.112 0-18.381 7.999-19.125 18.141-2.874-1.754-6.222-2.778-9.811-2.778-10.605 0-19.2 8.789-19.2 19.629v59.446h189.682l-.47-16.962z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ADD57F",
						d: "M903.94 877.722c-.971-1.263-1.098-2.977-.429-4.425a17.3 17.3 0 0 0 1.589-7.257c0-5.259-2.344-9.964-6.041-13.14-1.545-1.326-2.061-3.559-1.072-5.339a11.6 11.6 0 0 0 1.453-5.501c.069-6.274-5.072-11.636-11.343-11.815-6.608-.187-12.023 5.114-12.023 11.683 0 2.048.53 3.969 1.456 5.639.986 1.78.467 4.009-1.076 5.336-3.696 3.179-6.04 7.881-6.04 13.139 0 2.594.571 5.054 1.588 7.264.675 1.462.514 3.184-.466 4.465a20.34 20.34 0 0 0-4.147 13.696c.64 10.252 9.117 18.594 19.373 19.081 11.723.557 21.403-8.786 21.403-20.388 0-4.679-1.575-8.991-4.222-12.432z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#73DDDA",
						d: "M942.395 883.843c.147-1.007.176-2.051.075-3.118-.568-5.948-5.317-10.78-11.254-11.437-7.701-.851-14.22 5.157-14.22 12.689q.001.736.081 1.451c.524 4.647.014 9.392-1.875 13.67a15.9 15.9 0 0 0-1.311 7.459c.507 7.875 6.87 14.273 14.742 14.818 9.293.64 17.031-6.709 17.031-15.868a15.9 15.9 0 0 0-1.329-6.378c-1.828-4.171-2.601-8.78-1.94-13.286"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#006168",
						d: "M929.048 886.081h-2.258v51.916h2.258zM887.298 869.152h-2.257v68.846h2.257z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#123E6B",
						d: "M1167.25 393.107H1120v441.97h47.25z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#048982",
						d: "M1167.25 420.964h-47.05v8.189h47.05zM1167.25 448.82h-47.05v8.19h47.05zM1167.25 476.676h-47.05v8.189h47.05zM1167.25 504.532h-47.05v8.189h47.05zM1167.25 532.389h-47.05v8.189h47.05zM1167.25 560.245h-47.05v8.189h47.05zM1167.25 588.101h-47.05v8.189h47.05zM1167.25 615.954h-47.05v8.189h47.05zM1167.25 643.811h-47.05V652h47.05zM1167.25 671.667h-47.05v8.189h47.05zM1167.25 699.522h-47.05v8.19h47.05zM1167.25 727.379h-47.05v8.189h47.05z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#fff",
						d: "M1243.34 393.107h-76.09v441.97h76.09z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#73DDDA",
						d: "M1211.27 420.964h-14.54v8.189h14.54zM1190.68 420.964h-14.53v8.189h14.53zM1231.85 420.964h-14.53v8.189h14.53zM1190.68 448.82h-14.53v8.19h14.53zM1231.85 448.82h-14.53v8.19h14.53zM1211.27 448.82h-14.54v8.19h14.54zM1190.68 476.676h-14.53v8.189h14.53zM1231.85 476.676h-14.53v8.189h14.53zM1211.27 476.676h-14.54v8.189h14.54zM1231.85 504.532h-14.53v8.189h14.53zM1190.68 504.532h-14.53v8.189h14.53zM1211.27 504.532h-14.54v8.189h14.54zM1211.27 532.389h-14.54v8.189h14.54zM1190.68 532.389h-14.53v8.189h14.53zM1231.85 532.389h-14.53v8.189h14.53zM1231.85 560.245h-14.53v8.189h14.53zM1190.68 560.245h-14.53v8.189h14.53zM1211.27 560.245h-14.54v8.189h14.54zM1231.85 588.101h-14.53v8.189h14.53zM1211.27 588.101h-14.54v8.189h14.54zM1190.68 588.101h-14.53v8.189h14.53zM1231.85 615.954h-14.53v8.189h14.53zM1190.68 615.954h-14.53v8.189h14.53zM1211.27 615.954h-14.54v8.189h14.54zM1190.68 643.811h-14.53V652h14.53zM1211.27 643.811h-14.54V652h14.54zM1231.85 643.811h-14.53V652h14.53zM1211.27 671.667h-14.54v8.189h14.54zM1231.85 671.667h-14.53v8.189h14.53zM1190.68 671.667h-14.53v8.189h14.53zM1190.68 699.522h-14.53v8.19h14.53zM1211.27 699.522h-14.54v8.19h14.54zM1231.85 699.522h-14.53v8.19h14.53zM1231.85 727.379h-14.53v8.189h14.53zM1190.68 727.379h-14.53v8.189h14.53zM1211.27 727.379h-14.54v8.189h14.54z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#123E6B",
						d: "M1405.41 492.82v-20.036h-100.23v20.036h-6.19v445.443h106.11V492.82z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#048982",
						d: "M1398.91 492.82h-99.92v445.443h106.11V492.82z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#17AD86",
						d: "M1363.34 472.784h-120v465.479h120z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#048982",
						d: "M1363.34 472.784h-120v20.036h120z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#fff",
						d: "M1276.87 520.979h-11.04v20.691h11.04zM1298.2 520.979h-11.04v20.691h11.04zM1319.52 520.979h-11.03v20.691h11.03zM1340.85 520.979h-11.03v20.691h11.03zM1276.87 556.711h-11.04v20.691h11.04zM1298.2 556.711h-11.04v20.691h11.04zM1319.52 556.711h-11.03v20.691h11.03zM1340.85 556.711h-11.03v20.691h11.03zM1276.87 592.438h-11.04v20.691h11.04zM1298.2 592.438h-11.04v20.691h11.04zM1319.52 592.438h-11.03v20.691h11.03zM1340.85 592.438h-11.03v20.691h11.03zM1276.87 628.17h-11.04v20.691h11.04zM1298.2 628.17h-11.04v20.691h11.04zM1319.52 628.17h-11.03v20.691h11.03zM1340.85 628.17h-11.03v20.691h11.03z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#123E6B",
						d: "m1191.69 716.879-35.85-37.26h112.89l35.85 37.26z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ADD57F",
						d: "m1155.91 679.593-35.75 37.26v118.145h71.51V716.853z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#E6FDDE",
						d: "M1304.58 716.879h-112.89v118.198h112.89z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#1FB578",
						d: "M1227.44 734.235h-8.28v5.683h8.28zM1227.44 751.28h-8.28v5.683h8.28zM1252.27 734.235h-8.28v5.683h8.28zM1252.27 751.28h-8.28v5.683h8.28zM1277.11 734.235h-8.28v5.683h8.28zM1277.11 751.28h-8.28v5.683h8.28zM1227.44 768.325h-8.28v5.683h8.28zM1252.27 768.325h-8.28v5.683h8.28zM1277.11 768.325h-8.28v5.683h8.28z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#048982",
						d: "M1147.57 734.235h-8.28v5.683h8.28zM1147.57 751.28h-8.28v5.683h8.28zM1172.4 734.235h-8.28v5.683h8.28zM1172.4 751.28h-8.28v5.683h8.28zM1147.57 768.325h-8.28v5.683h8.28zM1172.4 768.325h-8.28v5.683h8.28z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#0A1866",
						d: "M1304.91 905.454h100.19V770.056c-1.23-7.959-14.05-21.629-32.1-12.398.02-.254-.43-10.001-9.37-17.668-7.38-6.329-20.1-11.844-34.09-4.921-.87-8.227-13.29-18.19-24.96-18.19z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#149977",
						d: "M1328.2 817.908c-27.07 6.738-31.3-2.642-65.03 1.304-26.02 3.043-33.28 19.309-56.47 15.565-23.33-3.762-53.9-11.957-86.7.499v102.869h285.11V802.747c-40.28-13.131-58.16 10.491-76.91 15.158z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#123E6B",
						d: "M1249.9 880.854c0 18.874 18.69 34.173 18.69 34.173s18.69-15.299 18.69-34.173-18.69-34.173-18.69-34.173-18.69 15.299-18.69 34.173"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#006168",
						d: "M1269.72 876.688h-2.26v61.459h2.26z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#57C5C6",
						d: "M1203.12 880.854c0 18.874 18.69 34.173 18.69 34.173s18.69-15.299 18.69-34.173-18.69-34.173-18.69-34.173-18.69 15.299-18.69 34.173"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#006168",
						d: "M1222.94 876.688h-2.26v61.459h2.26z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ADD57F",
						d: "M1156.34 880.854c0 18.874 18.69 34.173 18.69 34.173s18.69-15.299 18.69-34.173-18.69-34.173-18.69-34.173-18.69 15.299-18.69 34.173"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#006168",
						d: "M1176.15 876.688h-2.25v61.459h2.25z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#0E664F",
						d: "M1343.47 880.854c0 18.874 18.69 34.173 18.69 34.173s18.69-15.299 18.69-34.173-18.69-34.173-18.69-34.173-18.69 15.299-18.69 34.173"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#006168",
						d: "M1363.29 876.688h-2.26v61.459h2.26z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ADD57F",
						d: "M1296.69 880.854c0 18.874 18.68 34.173 18.68 34.173s18.69-15.299 18.69-34.173-18.69-34.173-18.69-34.173-18.68 15.299-18.68 34.173"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#006168",
						d: "M1316.5 876.688h-2.26v61.459h2.26z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#159C79",
						d: "M133.052 920.096c-39.425-8.435-45.454-23.832-92.674-30.972-52.951-8.007-67.462 11.856-100.782 2.781-45.325-12.346-69.212 15.017-134.654 1.474-48.084-9.952-104.934 33.859-171.442 44.696h726.653v-51.466c-91.46-34.698-188.125 41.829-227.101 33.49z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#17AD86",
						d: "M1159.08 994.852c-143.34 16.018-104.75 29.358-234.481 36.978-120.434 7.08-173.336-9.55-314.238-6.71-179.394 3.61-177.636 31.97-332.375 30.55-164.528-1.51-165.393-35.61-345.707-31.2-126.195 3.1-202.126 30.38-339.257 34.52-106.121 3.2-142.162-32.16-205.378-15.18v36.23H1405.11v-87.827c-71.36-4.944-175.53-5.239-246.03 2.639"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#159C79",
						d: "M891.534 1061.76c3.852.02 7.655.05 11.407.14 30.369.75 59.925-2.58 78.228-8.4 20.481-6.5 52.741-10.7 89.031-10.7 9.56 0 18.83.3 27.67.85 27.67 1.72 57.01-.18 78.6-4.65 19.51-4.04 44.78-6.47 72.42-6.47 38.73 0 72.83 4.78 92.93 12.05 14.44 5.22 37.57 8.69 63.29 9.22v26.24H784.36c1.554-.65 2.909-1.34 4.017-2.07 11.758-7.73 39.195-16.42 103.163-16.21z"
					})
				]
			}), /* @__PURE__ */ _jsx("path", {
				fill: "#C9ECF4",
				d: "M251.604 568.082H376.02c-.095-8.094-6.533-14.624-14.471-14.624q-.778.002-1.534.086c.046-.58.087-1.159.087-1.748 0-11.547-9.157-20.91-20.451-20.91-2.921 0-5.692.635-8.206 1.762-.597-7.615-6.819-13.606-14.419-13.606s-13.851 6.023-14.422 13.664a22.7 22.7 0 0 0-6.935-1.082c-12.796 0-23.167 10.604-23.167 23.686 0 .424.041.839.064 1.257a14.16 14.16 0 0 0-6.577-1.627c-7.447 0-13.574 5.752-14.382 13.145zM916.527 184.742a19.8 19.8 0 0 0-8.105 1.742c-.591-7.523-6.735-13.442-14.246-13.442s-13.684 5.951-14.249 13.5a22.4 22.4 0 0 0-6.851-1.068c-10.985 0-20.151 7.916-22.368 18.47h85.944c-.732-10.725-9.454-19.199-20.131-19.199zM807.424 303.743c-2.884 0-5.623.629-8.105 1.742-.591-7.523-6.736-13.442-14.246-13.442s-13.684 5.951-14.25 13.5a22.4 22.4 0 0 0-6.85-1.068c-10.985 0-20.151 7.916-22.369 18.47h85.945c-.732-10.725-9.454-19.199-20.131-19.199zM724.645 209.895a42.3 42.3 0 0 0-17.369 3.732c-1.263-16.121-14.433-28.805-30.528-28.805s-29.325 12.75-30.534 28.927a48 48 0 0 0-14.678-2.291c-23.539 0-43.186 16.964-47.932 39.579h184.178c-1.572-22.984-20.261-41.142-43.14-41.142z"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#C9ECF4",
			d: "M251 568.258h124.416c-.095-8.094-6.534-14.625-14.471-14.625-.519 0-1.03.032-1.534.087.046-.58.086-1.16.086-1.748 0-11.547-9.157-20.91-20.451-20.91-2.92 0-5.691.634-8.206 1.762-.596-7.615-6.818-13.606-14.419-13.606-7.6 0-13.851 6.023-14.422 13.664a22.7 22.7 0 0 0-6.934-1.082c-12.796 0-23.167 10.604-23.167 23.685 0 .424.04.84.063 1.258a14.14 14.14 0 0 0-6.576-1.627c-7.448 0-13.575 5.752-14.382 13.145zM724.041 210.072a42.3 42.3 0 0 0-17.369 3.732c-1.263-16.122-14.434-28.805-30.528-28.805s-29.326 12.75-30.534 28.926a48.1 48.1 0 0 0-14.679-2.29c-23.539 0-43.185 16.964-47.931 39.579h184.177c-1.571-22.984-20.26-41.142-43.139-41.142z"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "empty-state-full-page-1_svg__b",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M-612 0h2018v1080H-612z"
			})
		}) })
	]
});
export default SvgEmptyStateFullPage1;
